import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSpeechBubbleStack20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSpeechBubbleStack20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.797 12.692v-1.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h9.846a.5.5 0 0 1 .5.5v5.692a.5.5 0 0 1-.5.5H7.975l-.437.423-1.741 1.688zm7.049 0H8.582l-2.59 2.51c-.634.615-1.695.165-1.695-.718v-1.792H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9.846a2 2 0 0 1 2 2v5.692a2 2 0 0 1-2 2m-1.428 3.323H7.23l1.56-1.5h3.217l.432.402 1.763 1.643v-2.045H17a.5.5 0 0 0 .5-.5V8.7a.5.5 0 0 0-.5-.5h-.77V6.7H17a2 2 0 0 1 2 2v5.315a2 2 0 0 1-2 2h-1.297v1.694c0 .874-1.042 1.327-1.681.732z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSpeechBubbleStack20);
